import * as React from 'react';

import { Input, Form, Button, Radio } from 'antd';

import pickListAPI from './pickListAPI';
import { Validation } from 'src/common/utils';
import { Page, PageHero } from 'src/components/common';

interface IProps {
	actions?: any;
	className?: string;
	history?: any;
	match?: any;
	pickListTypes?: PickListType[];
}

interface IState {
	pickListType: PickListType;
	isDisabled: boolean;
}

class PickListTypeForm extends React.Component<IProps, IState> {
	public defaultPickListType = {
		id: undefined,
		code: '',
		description: '',
		parentId: undefined,
		isActive: undefined,
	};

	public state: IState = {
		pickListType: this.defaultPickListType,
		isDisabled: false,
	};

	public componentDidMount() {
		const pickListTypeId = this.props.match.params.pickListTypeId;
		if (pickListTypeId !== '0') {
			pickListAPI.getPickListType(pickListTypeId)
				.then((resp) => this.setState({ pickListType: resp, isDisabled: true }));
		}
	}

	public render() {
		const validPickListType = {
			code: Validation.validateStringIsNotEmpty(this.state.pickListType.code!, 'Enter in a picklist type code'),
			description: Validation.validateStringIsNotEmpty(this.state.pickListType.description!, 'Enter in a picklist type description'),
			isActive: Validation.validateIsActive(this.state.pickListType.isActive!)
		};

		const pickListTypeId = this.props.match.params.pickListTypeId;
		const { pickListType } = this.state;
		return (
			<Page>
				<PageHero>
					<h1 className={'mb-0'}>{`${pickListTypeId === '0' ? 'Add' : 'Edit'} ${pickListType.description!.length > 0 ? pickListType.description : 'picklist type'}`}</h1>
				</PageHero>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-3">
							<Form.Item
								validateStatus={validPickListType.code.validationStatus}
								help={validPickListType.code.message}
								hasFeedback={true}
								label="Picklist type code"
							>

								<Input
									name="code"
									onChange={this.savePickListTypeInfo}
									value={this.state.pickListType.code}
									disabled={this.state.isDisabled}
									placeholder="Enter a picklist type code"
								/>
							</Form.Item>
						</div>
						<div className="col-md-3">
							<Form.Item
								validateStatus={validPickListType.description.validationStatus}
								help={validPickListType.description.message}
								hasFeedback={false}
								label="Picklist type description"
							>
								<Input
									name="description"
									placeholder="Enter a picklist type description"
									onChange={this.savePickListTypeInfo}
									disabled={this.state.isDisabled}
									value={this.state.pickListType.description}
								/>
							</Form.Item>
						</div>
						<div className="col-md-3">
							<Form.Item
								validateStatus={validPickListType.isActive.validationStatus}
								help={validPickListType.isActive.message}
								hasFeedback={true}
								label="Picklist item Active"
							>
								<Radio.Group name="isActive" onChange={this.savePickListTypeInfo} value={this.state.pickListType.isActive}>
									<Radio value={true}>Active</Radio>
									<Radio value={false}>InActive</Radio>
								</Radio.Group>
							</Form.Item>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3">
							<Button
								type="primary"
								htmlType="submit"
								onClick={this.onSubmit}
								disabled={!this.isValid(validPickListType)}
								className={'mr-3'}
							>
								Save
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								onClick={() => this.props.history.push('/admin/pick-lists')}
							>
								Cancel
							</Button>
						</div>
					</div>
				</div>
			</Page>
		);
	}

	private savePickListTypeInfo = (e: any) => {
		let value = e.target.value!;
		if (value === 'true') {
			value = true;
		}
		if (value === 'false') {
			value = false;
		}
		let name = e.target.name;
		if (e.target.type === 'radio') {
			value = value;
		} else if (e.target.type === 'checkbox') {
			if (e.target.data !== undefined) {
				// If there's data then it's a checkbox group
				if (e.target.data.singleSelect) {
					value = value;
				} else {
					// Don't split if single value
					if (value === '') {
						value = [];
					} else {
						value = value.split(',');
					}
				}
				name = e.target.data.name;
			} else {
				value = e.target.checked;
			}
		}
		const pickListType = {
			...this.state.pickListType,
			[name]: value
		};

		this.setState({ pickListType });
	}

	private isValid = (validPickListType: any) => {
		const validateValues: string[] = Object.keys(validPickListType).map(key => validPickListType[key].validationStatus);
		return Validation.isValid(validateValues);
	}

	private onSubmit = () => {
		const { pickListType } = this.state;
		pickListAPI.savePickListType(pickListType)
			.then(() => this.props.history.push(`/admin/pick-lists`));
	}

}

export default PickListTypeForm;